import { useAuth0 } from '@auth0/auth0-react';
import type { AuthProvider } from '@refinedev/core';
import { axiosInstance } from '@refinedev/simple-rest';
import { logger } from 'shiver-core/logger';

export function useDummyAuthProvider(): AuthProvider {
  return {
    login: async () => {
      return {
        success: true,
      };
    },
    logout: async () => {
      return {
        success: true,
      };
    },
    onError: async (error) => {
      logger.error(error);
      return { error };
    },
    check: async () => {
      return {
        authenticated: true,
      };
    },
  };
}

export function useAuthProvider(): AuthProvider | undefined {
  const { isLoading, user, logout, getAccessTokenSilently } = useAuth0();

  if (isLoading) {
    return undefined;
  }

  return {
    login: async () => {
      return {
        success: true,
      };
    },
    logout: async () => {
      await logout();
      return {
        success: true,
      };
    },
    onError: async (error) => {
      logger.error(error);
      return { error };
    },
    check: async () => {
      try {
        const token = await getAccessTokenSilently();

        if (token) {
          document.cookie = `token=${token}; path=/;`;

          // TODO: Cookieベースに統一する
          axiosInstance.defaults.headers.common = {
            Authorization: `Bearer ${token}`,
          };
          return {
            authenticated: true,
          };
        } else {
          return {
            authenticated: false,
            error: {
              message: 'Check failed',
              name: 'Token not found',
            },
            redirectTo: '/login',
            logout: true,
          };
        }
      } catch (error: unknown) {
        return {
          authenticated: false,
          error: error instanceof Error ? error : new Error(String(error)),
          redirectTo: '/login',
          logout: true,
        };
      }
    },
    getPermissions: async () => {},
    getIdentity: async () => {
      return user;
    },
  };
}
